import { html } from "lit";

export default html`
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="225" height="45" viewBox="0 0 700 170">
    <style type="text/css">
        .st0 {
            fill: #E31B22;
        }

        .st1 {
            fill: #003E7E;
        }

        .st2 {
            fill: #231F20;
        }

        .st3 {
            fill: #DF5B26;
        }

        .st4 {
            fill: #221F1F;
        }
    </style>
    <g>
        <g>
            <path class="st1" d="M74,9L11,161.4h38.1L63.8,126h58l14.6,35.4h37.9L111.3,9H74z M71.1,98.8l21.7-53.2l21.7,53.2H71.1z
			 M239.7,133.8c-3.6-0.2-6.6-0.6-9.1-1c-2.5-0.5-4.6-1.1-6.3-1.9c-1.7-0.8-3.3-1.9-4.8-3.3c-1.5-1.4-2.7-2.6-3.5-3.7
			c-0.8-1.1-1.5-2.7-2.1-4.9c-0.5-2.2-0.9-5.2-1.1-8.9c-0.2-3.7-0.5-8.9-0.8-15.7V9h-32.4v85.4c0,7.9,0.3,14.9,0.9,20.9
			c0.6,6,1.5,10.8,2.7,14.3c2.4,7.3,6.4,13.5,12,18.5c5.6,5,12.2,8.6,20,10.7c2,0.5,3.8,0.9,5.6,1.3c1.7,0.4,3.9,0.6,6.4,0.8
			c2.5,0.2,5.5,0.3,9,0.3c3.5,0.1,7.9,0.1,13.2,0.1h34.5v-27.2h-31.1C247.6,134.2,243.2,134.1,239.7,133.8z M342,9.7
			c-4,0.5-7.6,1.1-10.8,2.1c-3.3,0.9-6.3,2.2-9,3.8c-2.7,1.6-5.5,3.5-8.2,5.8c-17.2,14.5-25.8,35.5-25.8,63.1
			c0,12.6,1.7,24.1,5.1,34.3c3.4,10.2,8.4,18.7,15,25.6c3,3.2,6.4,5.9,9.9,8.1c3.6,2.2,7.7,4,12.4,5.3c4.7,1.3,10.2,2.2,16.3,2.9
			c6.2,0.6,13.3,0.9,21.4,0.9h42.3v-27.2h-40.9c-7.8,0-14.4-0.6-19.8-1.8c-5.4-1.2-9.9-3.2-13.4-5.9c-3.5-2.7-6.2-6.3-8-10.7
			c-1.8-4.4-3.1-9.9-3.7-16.4h85.7V72.1h-85.7c0.3-3.8,0.6-6.9,0.9-9.4c0.3-2.4,0.7-4.5,1.1-6.3c0.5-1.8,1-3.3,1.7-4.7
			c0.7-1.4,1.6-2.8,2.9-4.3c1.7-2.1,3.5-3.9,5.5-5.4c2-1.4,4.4-2.6,7.2-3.4c2.8-0.8,6.2-1.4,10-1.8c3.9-0.4,8.6-0.6,14-0.6h42.3V9
			h-54.8C350.6,9,346,9.2,342,9.7z M524.8,9l-58.3,75.2l55.1,77.2h42.7l-60.5-77.2L567.2,9H524.8z M432.9,161.4h32.4V9h-32.4V161.4z
			 M713.1,97.4c-2.1-6.1-4.8-10.9-8.3-14.4c-4.4-4.6-10-7.8-16.7-9.7c-6.7-1.9-15.6-2.9-26.7-2.9h-24.4c-5.8,0-10.2-0.2-13.1-0.7
			c-3-0.5-5.5-1.4-7.7-2.7c-4.7-2.9-7.1-7.5-7.1-13.9c0-7,2.4-11.8,7.3-14.4c1.8-1.1,4.4-1.7,7.6-2.1c3.3-0.3,8.5-0.5,15.6-0.5h68.1
			V9h-75.4c-4.4,0-8.3,0-11.6,0.1c-3.4,0.1-6.3,0.2-8.8,0.5c-2.5,0.2-4.8,0.6-6.7,1c-2,0.5-3.8,1-5.5,1.6c-7.9,2.7-14.3,8-19.2,15.7
			c-4.9,7.7-7.3,16.4-7.3,26.1c0,6.7,1.3,13,3.8,18.8c2.5,5.9,6.1,10.8,10.6,14.7c4,3.5,9,6,15.2,7.6c6.2,1.6,13.8,2.4,22.9,2.4
			h28.1c3.6,0,6.9,0.2,9.7,0.7c2.8,0.5,5.1,1.1,6.7,2.1c3,1.5,5.4,3.7,7.2,6.6c1.7,2.9,2.6,6.1,2.6,9.6c0,6.2-2.5,10.9-7.5,13.9
			c-2,1.2-4.7,2.1-8.2,2.7c-3.5,0.6-8.3,0.9-14.4,0.9h-69.4v27.2H657c5.6,0,10.5-0.1,14.6-0.3c4.1-0.2,7.7-0.6,10.9-1
			c3.1-0.5,5.8-1.1,8.1-1.8c2.3-0.8,4.3-1.8,6.2-3c5.9-3.7,10.7-8.9,14.2-15.9c3.5-6.9,5.3-14.5,5.3-22.7
			C716.2,109.9,715.2,103.5,713.1,97.4z"/>
            <path class="st1" d="M743.1,9.9c2.6,0,5,0.5,7.3,1.5c2.3,1,4.3,2.4,6,4.1c1.7,1.7,3.1,3.7,4.1,6c1,2.3,1.5,4.8,1.5,7.3
			c0,2.6-0.5,5.1-1.5,7.4c-1,2.3-2.4,4.3-4.1,6c-1.7,1.7-3.8,3.1-6.1,4.1c-2.3,1-4.8,1.5-7.4,1.5c-2.6,0-5.1-0.5-7.4-1.5
			c-2.3-1-4.3-2.3-6.1-4.1c-1.7-1.7-3.1-3.7-4.1-6c-1-2.3-1.5-4.7-1.5-7.4c0-2.7,0.5-5.1,1.5-7.5c1-2.3,2.4-4.3,4.1-6
			c1.7-1.7,3.8-3.1,6.1-4C737.9,10.4,740.4,9.9,743.1,9.9z M743.1,13.5c-2.2,0-4.2,0.4-6,1.2c-1.9,0.8-3.5,1.9-4.9,3.3
			c-1.4,1.4-2.5,3-3.3,4.9c-0.8,1.9-1.2,3.9-1.2,6c0,2.1,0.4,4.1,1.2,6c0.8,1.9,1.9,3.5,3.3,4.9c1.4,1.4,3,2.5,4.8,3.3
			c1.8,0.8,3.8,1.2,5.9,1.2c2.1,0,4.1-0.4,5.9-1.2c1.8-0.8,3.4-1.9,4.8-3.3c1.4-1.4,2.5-3,3.3-4.9c0.8-1.9,1.2-3.9,1.2-6
			c0-2.1-0.4-4.1-1.2-5.9c-0.8-1.9-1.9-3.5-3.2-4.9c-1.4-1.4-3-2.5-4.8-3.3C747,13.9,745.1,13.5,743.1,13.5z M738.8,39.2h-5.3v-21
			h9.6c1.8,0,3.2,0.1,4.3,0.3c1.1,0.2,2,0.5,2.8,0.9c0.9,0.5,1.5,1.2,2,2c0.5,0.8,0.7,1.7,0.7,2.7c0,1.5-0.3,2.8-1,3.8
			c-0.7,1-1.7,1.8-3,2.2c2.4,0.7,3.6,2.6,3.8,5.7c0,0.6,0.1,1,0.1,1.3c0,0.3,0.1,0.6,0.1,0.8c0.1,0.2,0.1,0.4,0.2,0.6
			c0.1,0.2,0.1,0.4,0.2,0.7h-6c0-0.3-0.1-0.4-0.2-0.5l-0.2-1.1l-0.2-1.4c-0.1-0.9-0.3-1.7-0.5-2.3c-0.2-0.6-0.6-1.1-1.1-1.5
			c-0.5-0.4-1.1-0.6-1.8-0.8c-0.7-0.2-1.6-0.2-2.7-0.2h-1.9V39.2z M743.7,27.3c1.3,0,2.1-0.2,2.6-0.6c0.5-0.4,0.8-1.1,0.8-2
			c0-0.9-0.2-1.5-0.8-1.9c-0.5-0.4-1.4-0.6-2.6-0.6h-4.9v5.1H743.7z"/>
        </g>
    </g>
</svg>
`;
